<template>
  <el-table border :data="rows">
    <el-table-column>
      <template slot-scope="{ row }">
        <span class="inline-block rich-text break-words" v-html="row.content.richText || row.content.text"></span>
      </template>
    </el-table-column>
    <el-table-column v-for="(column, index) in columns" :key="column.id" :column-key="column.id">
      <template slot="header">
        <span class="text-red" v-if="column.required">*</span>
        <section class="inline-block rich-text break-words" v-html="column.content.richText || column.content.text"></section>
      </template>
      <template slot-scope="{ row }">
        <slot name="content" :row="row" :col="column"></slot>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'MatrixTable',
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    rows: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped></style>
